<template>
  <div>
    <review-card
      v-for="(review, i) in reviews"
      :key="i"
      :review="review"
      @archive="$emit('archive', review)"
      @unarchive="$emit('unarchive', review)"
      @delete="$emit('delete', review)"
    />
  </div>
</template>

<script>
import ReviewCard from './ReviewCard';

export default {
  name: 'ReviewCardList',
  components: { ReviewCard },
  props: {
    reviews: {
      type: Array,
      default: () => [],
    },
  },
  emits: ['archive', 'unarchive', 'delete'],
};
</script>
